













import Vue from 'vue'
import Substitution from '@/components/disposition/Substitution.vue'
import DispositionRepresentative from '@/components/disposition/DispositionRepresentative.vue'

interface ComponentData {
  activeTab: number
}

export default Vue.extend({
  name: 'SubstitutionPage',

  components: {
    Substitution,
    DispositionRepresentative
  },

  data (): ComponentData {
    return {
      activeTab: 0
    }
  },

  watch: {},

  computed: {},


  methods: {

  },

  mounted () {

  }
})
